import { gql } from '@apollo/client';
import each from 'lodash/each';
import BaseService from './baseService';

class ProviderService extends BaseService {
  constructor(uri) {
    super(uri);
    this.providerServicesDataMappings = {
      serviceRateId: {
        name: '$serviceRateId',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'serviceRateId'
      },
      providerId: {
        name: '$providerId',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'providerId'
      },
      serviceIds: {
        name: '$serviceIds',
        type: '[Int]',
        typeRequire: '[Int!]',
        input: 'serviceIds'
      },
      serviceRate: {
        name: '$serviceRate',
        type: 'Float',
        typeRequire: 'Float!',
        input: 'serviceRate'
      },
      goaRate: {
        name: '$goaRate',
        type: 'Float',
        typeRequire: 'Float!',
        input: 'goaRate'
      },
      freeLoadedMiles: {
        name: '$freeLoadedMiles',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'freeLoadedMiles'
      },
      freeUnloadedMiles: {
        name: '$freeUnloadedMiles',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'freeUnloadedMiles'
      },
      loadedMileageRate: {
        name: '$loadedMileageRate',
        type: 'Float',
        typeRequire: 'Float!',
        input: 'loadedMileageRate'
      },
      unloadedMileageRate: {
        name: '$unloadedMileageRate',
        type: 'Float',
        typeRequire: 'Float!',
        input: 'unloadedMileageRate'
      },
      additionalRate: {
        name: '$additionalRate',
        type: 'Float',
        typeRequire: 'Float!',
        input: 'additionalRate'
      },
      surchargeRate: {
        name: '$surchargeRate',
        type: 'Float',
        typeRequire: 'Float!',
        input: 'surchargeRate'
      },
      surchargeExpireDays: {
        name: '$surchargeExpireDays',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'surchargeExpireDays'
      }
    };
    this.providerLocationDataMappings = {
      providerLocationId: {
        name: '$providerLocationId',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'providerLocationId'
      },
      hoursOfOperationProfileId: {
        name: '$hoursOfOperationProfileId',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'hoursOfOperationProfileId'
      },
      providerId: {
        name: '$providerId',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'providerId'
      },
      name: {
        name: '$name',
        type: 'String',
        typeRequire: 'String!',
        input: 'name'
      },
      active: {
        name: '$active',
        type: 'Int',
        typeRequire: 'Int!',
        input: 'active'
      },
      coverageAreas: {
        name: '$coverageAreas',
        type: '[[JSON]]',
        input: 'coverageAreas'
      },
      addresses: {
        name: '$addresses',
        type: '[AddressIn]',
        typeRequire: '[AddressIn!]',
        input: 'addresses'
      },
      phones: {
        name: '$phones',
        type: '[PhoneIn]',
        typeRequire: '[PhoneIn!]',
        input: 'phones'
      }
    };
    this.providerDataMappings = {
      providerId: {
        name: '$providerId',
        type: 'Int',
        input: 'providerId'
      },
      businessName: {
        name: '$businessName',
        type: 'String',
        typeRequire: 'String!',
        input: 'businessName'
      },
      businessEmail: {
        name: '$businessEmail',
        type: 'String',
        typeRequire: 'String!',
        input: 'businessEmail'
      },
      coverageAreas: {
        name: '$coverageAreas',
        type: '[[JSON]]',
        input: 'coverageAreas'
      },
      businessNameDBA: {
        name: '$businessNameDBA',
        type: 'String',
        input: 'businessNameDba'
      },
      businessWebsite: {
        name: '$businessWebsite',
        type: 'String',
        input: 'businessWebsite'
      },
      companyCode: {
        name: '$companyCode',
        type: 'String',
        input: 'companyCode'
      },
      logo: {
        name: '$logo',
        type: 'String',
        input: 'logo'
      },
      addresses: {
        name: '$addresses',
        type: '[AddressIn]',
        input: 'addresses'
      },
      vehicles: {
        name: '$vehicles',
        type: '[VehicleIn]',
        input: 'vehicles'
      },
      phones: {
        name: '$phones',
        type: '[PhoneIn]',
        input: 'phones'
      },
      chatEmailNotification: {
        name: '$chatEmailNotification',
        type: 'Int',
        input: 'chatEmailNotification'
      },
      chatPushNotification: {
        name: '$chatPushNotification',
        type: 'Int',
        input: 'chatPushNotification'
      },
      chatSmsNotification: {
        name: '$chatSmsNotification',
        type: 'Int',
        input: 'chatSmsNotification'
      },
      chatEmail: {
        name: '$chatEmail',
        type: 'String',
        input: 'chatEmail'
      },
      chatTelephoneNumber: {
        name: '$chatTelephoneNumber',
        type: 'String',
        input: 'chatTelephoneNumber'
      },
      billingEmailNotification: {
        name: '$billingEmailNotification',
        type: 'Int',
        input: 'billingEmailNotification'
      },
      billingPushNotification: {
        name: '$billingPushNotification',
        type: 'Int',
        input: 'billingPushNotification'
      },
      billingSmsNotification: {
        name: '$billingSmsNotification',
        type: 'Int',
        input: 'billingSmsNotification'
      },
      billingEmail: {
        name: '$billingEmail',
        type: 'String',
        input: 'billingEmail'
      },
      billingTelephoneNumber: {
        name: '$billingTelephoneNumber',
        type: 'String',
        input: 'billingTelephoneNumber'
      },
      systemPhoneNotification: {
        name: '$systemPhoneNotification',
        type: 'Int',
        input: 'systemPhoneNotification'
      },
      systemSmsNotification: {
        name: '$systemSmsNotification',
        type: 'Int',
        input: 'systemSmsNotification'
      },
      systemPushNotification: {
        name: '$systemPushNotification',
        type: 'Int',
        input: 'systemPushNotification'
      },
      systemEmailNotification: {
        name: '$systemEmailNotification',
        type: 'Int',
        input: 'systemEmailNotification'
      },
      systemTelephoneNumber: {
        name: '$systemTelephoneNumber',
        type: 'String',
        input: 'systemTelephoneNumber'
      },
      systemEmail: {
        name: '$systemEmail',
        type: 'String',
        input: 'systemEmail'
      }
    };
    this.provideServiceGql = `
      serviceRateId
      providerId
      serviceId
      service
      serviceKey
      serviceRate
      goaRate
      freeLoadedMiles
      freeUnloadedMiles
      loadedMileageRate
      unloadedMileageRate
      additionalRate
      surchargeRate
      surchargeExpireDays
      dateCreated
      dateModified
    `;
    this.providerGql = `
        providerId
        dateCreated
        dateModified
        businessName
        businessNameDba
        companyCode
        logo
        businessWebsite
        businessEmail
        coverageAreas
        addresses{
          addressType
          addressId
          fullAddress
          googleLocationId
          address
          city
          stateProvidence
          postalCode
          latitude
          longitude
          addressTypeId
        }
        phones{
          phoneType
          telephoneNumberId
          telephoneNumber
          telephoneName
          phoneTypeId
        }
        systemEmailNotification
        systemPushNotification
        systemSmsNotification
        systemPhoneNotification
        systemEmail
        systemTelephoneNumber
        chatEmailNotification
        chatPushNotification
        chatSmsNotification
        chatEmail
        chatTelephoneNumber
        billingEmailNotification
        billingPushNotification
        billingSmsNotification
        billingEmail
        billingTelephoneNumber
        `;
    this.providerLocationsGql = `
        providerLocationId
        providerId
        hoursOfOperationProfileId
        name
        active
        coverageAreas
        addresses{
            addressId
            fullAddress
            city
            stateProvidence 
            postalCode
            Country
            addressTypeId
        }
        phones{
            telephoneNumberId
            telephoneNumber
            telephoneName
            phoneTypeId
        }`;
    this.providerActionGql = `
      success
      token`;
  }

  buildProviderGQL = (data, mutation, required, actionReturned) => {
    const keys = Object.keys(data);
    const provider = [];
    const input = [];
    each(keys, (key) => {
      const map = this.providerDataMappings[key];
      if (map && data[key] !== null && data[key] !== undefined) {
        provider.push(`${map.name}: ${required && map.typeRequire ? map.typeRequire : map.type}`);
        input.push(`${map.input}: ${map.name}`);
      }
    });
    return `
      mutation Provider(${provider.join(', ')}){
        ${mutation || 'updateProvider'}(
            ${input.join('\n')}
          ) {
            ${actionReturned ? this.providerActionGql : this.providerGql}
        }
    }`;
  };

  buildProviderLocationGQL = (data, mutation, required, actionReturned) => {
    const keys = Object.keys(data);
    const provider = [];
    const input = [];
    each(keys, (key) => {
      const map = this.providerLocationDataMappings[key];
      if (map && data[key] !== undefined && data[key] !== null && data[key] !== 'undefined' && data[key] !== 'null') {
        provider.push(`${map.name}: ${required && map.typeRequire ? map.typeRequire : map.type}`);
        input.push(`${map.input}: ${map.name}`);
      }
    });
    return `
      mutation ProviderLocation(${provider.join(', ')}){
        ${mutation || 'updateProviderLocation'}(
            ${input.join('\n')}
          ) {
            ${actionReturned ? this.providerActionGql : this.providerLocationsGql}
        }
    }`;
  };

  buildProviderServicesGQL = (data, mutation, required, actionReturned) => {
    const keys = Object.keys(data);
    const provider = [];
    const input = [];
    each(keys, (key) => {
      const map = this.providerServicesDataMappings[key];
      if (map && data[key] !== undefined && data[key] !== null && data[key] !== 'undefined' && data[key] !== 'null') {
        provider.push(`${map.name}: ${required && map.typeRequire ? map.typeRequire : map.type}`);
        input.push(`${map.input}: ${map.name}`);
      }
    });
    return `
      mutation ProviderLocation(${provider.join(', ')}){
        ${mutation || 'updateProviderLocation'}(
            ${input.join('\n')}
          ) {
            ${actionReturned ? this.providerActionGql : this.provideServiceGql}
        }
    }`;
  };

  addHourOfOperationProfile = async (data) => {
    const HOURS_OF_OPERATION = gql`
      mutation HoursOfOperationProfile($profileName: String!, $providerId: Int!, $description: String!, $days: [HoursOfOperationDayIn!]) {
        addHoursOfOperation(profileName: $profileName, providerId: $providerId, description: $description, days: $days) {
          hoursOfOperationProfileId
        }
      }
    `;

    const resp = await this.client.mutate({
      mutation: HOURS_OF_OPERATION,
      variables: data
    });
    return resp.data;
  };

  addProviderServices = (data) => new Promise((resolve, reject) => {
    const NEW_PROVIDER = gql`
      ${this.buildProviderServicesGQL(data, 'addProviderServices', true)}
    `;

    this.client
      .mutate({
        mutation: NEW_PROVIDER,
        variables: data
      })
      .then((result) => {
        if (result.data.addProviderServices) {
          resolve(result.data.addProviderServices);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('addProviderServices: error', error);
        reject(error);
      });
  });

  deleteProviderServices = (serviceIds) => new Promise((resolve, reject) => {
    const DELETE_PROVIDER_SERVICE = gql`
      mutation ProviderServices($serviceIds: [Int]!){
        removeProviderServices(
          serviceIds: $serviceIds
        ){
          success
          token
        }
      }
    `;

    this.client
      .mutate({
        mutation: DELETE_PROVIDER_SERVICE,
        variables: { serviceIds }
      })
      .then((result) => {
        if (result.data.removeProviderServices) {
          resolve(result.data.removeProviderServices);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getProviderServices = (providerId) => new Promise((resolve, reject) => {
    const PROVIDER_SERVICES = gql`
      query ProviderServices($providerId: Int!){
        providerServices(providerId: $providerId){
            ${this.provideServiceGql}
        }
    }`;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDER_SERVICES,
        variables: { providerId }
      })
      .then((result) => {
        if (result.data.providerServices) {
          resolve(result.data.providerServices);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getAvailableProvider = (data) => new Promise((resolve, reject) => {
    const PROVIDER_SERVICES = gql`
      query OptionalProviders($location:JSON,$clientPickUpTime:DateTime,$service:String){
        optionalProviders(location: $location,clientPickUpTime:$clientPickUpTime,service:$service){
          providerLocationId
          providerId
          businessName
        }
      }`;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDER_SERVICES,
        variables: data
      })
      .then((result) => {
        if (result.data.optionalProviders) {
          console.log('optionalProviders', result.data.optionalProviders);
          resolve(result.data.optionalProviders);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getProviderService = (serviceRateId) => new Promise((resolve, reject) => {
    const PROVIDER_SERVICES = gql`
      query ProviderService($serviceRateId: Int!){
        providerService(serviceRateId: $serviceRateId){
            ${this.provideServiceGql}
        }
    }`;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDER_SERVICES,
        variables: { serviceRateId }
      })
      .then((result) => {
        if (result.data.providerService) {
          resolve(result.data.providerService);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  updateProviderService = (data) => new Promise((resolve, reject) => {
    const UPDATE_PROVIDER = gql`
      ${this.buildProviderServicesGQL(data, 'updateProviderService', true)}
    `;

    this.client
      .mutate({
        mutation: UPDATE_PROVIDER,
        variables: { ...data }
      })
      .then((result) => {
        if (result.data.updateProviderService) {
          resolve(result.data.updateProviderService);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  deleteProvider = (ids) => new Promise((resolve, reject) => {
    const DELETE_PROVIDER = gql`
      mutation Provider($ids: [Int]!){
        removeProviders(
          Ids: $ids
        ){
          success
          token
        }
      }
    `;

    this.client
      .mutate({
        mutation: DELETE_PROVIDER,
        variables: { ids }
      })
      .then((result) => {
        if (result.data.removeProviders) {
          resolve(result.data.removeProviders);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  addProvider = (data) => new Promise((resolve, reject) => {
    const NEW_PROVIDER = gql`
      ${this.buildProviderGQL(data, 'addProvider', true)}
    `;

    this.client
      .mutate({
        mutation: NEW_PROVIDER,
        variables: data
      })
      .then((result) => {
        if (result.data.addProvider) {
          resolve(result.data.addProvider);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  addProviderLocation = (data) => new Promise((resolve, reject) => {
    delete data.providerLocationId;
    const PROVIDER = gql`${this.buildProviderLocationGQL(data, 'addProviderLocation', true, false)}`;

    this.client
      .mutate({
        mutation: PROVIDER,
        variables: data
      })
      .then((result) => {
        if (result.data.addProviderLocation) {
          resolve(result.data.addProviderLocation);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  saveProviderLocation = (data) => new Promise((resolve, reject) => {
    const PROVIDER = gql`${this.buildProviderLocationGQL(data, 'updateProviderLocation', true, false)}`;

    this.client
      .mutate({
        mutation: PROVIDER,
        variables: data
      })
      .then((result) => {
        if (result.data.updateProviderLocation) {
          resolve(result.data.updateProviderLocation);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  saveProvider = (data) => new Promise((resolve, reject) => {
    const PROVIDER = gql`${this.buildProviderGQL(data, 'updateProvider', false, false)}`;
    this.client
      .mutate({
        mutation: PROVIDER,
        variables: data
      })
      .then((result) => {
        if (result.data.updateProvider) {
          resolve(result.data.updateProvider);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  savePhones = (providerId, phones) => new Promise((resolve, reject) => {
    const PROVIDER_PHONES = gql`
      mutation Provider($providerId: Int!, $phones: [PhoneUpdate]){
        updateProviderPhones(
            providerId: providerId
            phones: $phones
          ) {
            success
            token
            error
            provider{
                ${this.providerGql}
            }
        }
    }
    `;

    this.client
      .mutate({
        mutation: PROVIDER_PHONES,
        variables: {
          providerId,
          phones
        }
      })
      .then((result) => {
        if (result.data.updateProviderPhones) {
          resolve(result.data.updateProviderPhones);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  saveAddresses = (providerId, addresses) => new Promise((resolve, reject) => {
    const PROVIDER_ADDRESSES = gql`
      mutation Provider($providerId: Int!, $addresses: [AddressUpdate]){
        updateProviderAddresses(
            providerId: $providerId
            addresses: $addresses
          ) {
            success
            token
            error
            provider{
              ${this.providerGql}
            }
        }
    }
    `;

    this.client
      .mutate({
        mutation: PROVIDER_ADDRESSES,
        variables: {
          providerId,
          addresses
        }
      })
      .then((result) => {
        if (result.data.updateProviderAddresses) {
          resolve(result.data.updateProviderAddresses);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getProviders = () => new Promise((resolve, reject) => {
    const PROVIDERS = gql`
      query {
        providers{
            ${this.providerGql}
        }
    }`;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDERS
      })
      .then((result) => {
        if (result.data.providers) {
          resolve(result.data.providers);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getProvider = (providerId) => new Promise((resolve, reject) => {
    const PROVIDER = gql`
      query Provider($providerId: Int!){
        provider(providerId: $providerId){
            ${this.providerGql}
        }
    }`;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDER,
        variables: { providerId }
      })
      .then((result) => {
        if (result.data.provider) {
          resolve(result.data.provider);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getProviderLocations = (providerId, gqlOverride, active) => new Promise((resolve, reject) => {
    const PROVIDER = gql`
      query ProviderLocations($providerId: Int!, $active: Int){
        providerLocations(providerId: $providerId, active: $active){
            ${gqlOverride || this.providerLocationsGql}
        }
    }`;

    let activeOnly = null;
    if (active === true) {
      activeOnly = 1;
    }
    if (activeOnly === false) {
      activeOnly = 0;
    }

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDER,
        variables: {
          providerId: parseInt(providerId),
          active: activeOnly
        }
      })
      .then((result) => {
        if (result.data.providerLocations) {
          resolve(result.data.providerLocations);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getActiveProviderLocations = (providerId, gqlOverride) => new Promise((resolve, reject) => {
    const PROVIDER = gql`
      query ProviderLocations($providerId: Int!, $active: Int){
        providerLocations(providerId: $providerId, active: $active){
            ${gqlOverride || this.providerLocationsGql}
        }
    }`;
    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDER,
        variables: {
          providerId: parseInt(providerId),
          active: 1
        }
      })
      .then((result) => {
        if (result.data.providerLocations) {
          resolve(result.data.providerLocations);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getProviderLocation = (providerLocationId, gqlOverride) => new Promise((resolve, reject) => {
    const PROVIDER = gql`
      query ProviderLocation($providerLocationId: Int!){
        providerLocation(providerLocationId: $providerLocationId){
            ${gqlOverride || this.providerLocationsGql}
        }
    }`;
    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDER,
        variables: { providerLocationId: parseInt(providerLocationId) }
      })
      .then((result) => {
        if (result.data.providerLocation) {
          resolve(result.data.providerLocation);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });

  getProviderByCompanyCode = (companyCode) => new Promise((resolve, reject) => {
    const PROVIDER = gql`
      query Provider($companyCode: String){
        provider(companyCode: $companyCode){
            ${this.providerGql}
        }
    }`;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: PROVIDER,
        variables: { companyCode }
      })
      .then((result) => {
        if (result.data.provider) {
          resolve(result);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}

const providerService = new ProviderService(`${process.env.REACT_APP_PROVIDER_API}/graphql`);

export default providerService;
